import { render, staticRenderFns } from "./CustomerAssignmentListing.vue?vue&type=template&id=7001015a"
import script from "./CustomerAssignmentListing.vue?vue&type=script&lang=js"
export * from "./CustomerAssignmentListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports